import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { selectObservationsById } from "../observations/slice"
import { selectCollectionsById } from "./slice"
import { slideFromTop } from "../../ui/animations"
import Breadcrumbs from "../../ui/Breadcrumbs"

// TODO: Move to common UI component def for floating app bar
const Bar = styled.div`
  display: flex;
  padding: 1rem;
  background-color: ${(props) => props.theme.colours.paper};
  animation: 0.5s ${slideFromTop} ease-out;
`

const CollectionBar = ({ collectionId, observationId }) => {
  const observationsByID = useSelector(selectObservationsById)
  const observation = observationsByID[observationId]
  const collectionsByID = useSelector(selectCollectionsById)
  const collection = collectionsByID[collectionId]

  return collection && observation ? (
    <Bar>
      {observation && collection && (
        <Breadcrumbs>
          <span>Browsing in collection</span>
          <Link to={`/collections/${collection.id}`}>{collection.name}</Link>
        </Breadcrumbs>
      )}
      <CollectionNavControls
        collection={collection}
        observationId={observationId}
      />
    </Bar>
  ) : null
}

const useKeyPress = function (targetKey) {
  const [keyPressed, setKeyPressed] = useState(false)

  function downHandler({ key }) {
    if (key === targetKey) {
      setKeyPressed(true)
    }
  }

  const upHandler = ({ key }) => {
    if (key === targetKey) {
      setKeyPressed(false)
    }
  }

  React.useEffect(() => {
    window.addEventListener("keydown", downHandler)
    window.addEventListener("keyup", upHandler)

    return () => {
      window.removeEventListener("keydown", downHandler)
      window.removeEventListener("keyup", upHandler)
    }
  })

  return keyPressed
}

const NavContainer = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  * {
    margin-left: 0.5rem;
  }
  input {
    width: 2rem;
  }
`
const CollectionNavControls = ({ collection = {}, observationId }) => {
  const navigate = useNavigate()

  const [navIndex, setNavIndex] = useState(0)

  const onBack = (currentIndex, collection) => {
    if (collection?.recordings?.length > 0) {
      const nextIndex =
        currentIndex <= collection.recordings.length && currentIndex > 1
          ? currentIndex - 1
          : collection.recordings.length
      setNavIndex(nextIndex)
      navigate({
        pathname: `/observations/${collection.recordings[nextIndex - 1]}`,
        search: `?collection_id=${collection.id}`,
      })
    }
  }

  const onForward = (currentIndex, collection = {}) => {
    if (collection.recordings && collection.recordings.length > 0) {
      const nextIndex =
        currentIndex < collection.recordings.length ? currentIndex + 1 : 1
      setNavIndex(nextIndex)
      navigate({
        pathname: `/observations/${collection.recordings[nextIndex - 1]}`,
        search: `?collection_id=${collection.id}`,
      })
    }
  }

  const onEnter = (targetValue, collection) => {
    if (
      collection &&
      collection.recordings &&
      collection.recordings[targetValue]
    ) {
      navigate({
        pathname: `/observations/${collection.recordings[targetValue - 1]}`,
        search: `?collection_id=${collection.id}`,
      })
    }
  }
  useEffect(() => {
    const currentIndex =
      collection && collection.recordings
        ? collection.recordings.indexOf(observationId) + 1
        : 1
    setNavIndex(() => currentIndex)
  }, [])
  const leftPress = useKeyPress("ArrowLeft")
  const rightPress = useKeyPress("ArrowRight")
  useEffect(() => {
    if (collection?.recordings?.length > 0 && leftPress) {
      onBack(navIndex, collection)
    }
  }, [leftPress])
  useEffect(() => {
    if (collection?.recordings?.length > 0 && rightPress) {
      onForward(navIndex, collection)
    }
  }, [rightPress])

  return (
    <NavContainer>
      <span onClick={() => onBack(navIndex, collection)}>◀</span>
      <input
        value={navIndex}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onEnter(e.target.value, collection)
          }
        }}
        onChange={(e) => {
          setNavIndex(e.target.value)
        }}
      />
      <span>/</span>
      <span>{collection.recordings ? collection.recordings.length : 0}</span>
      <span onClick={() => onForward(navIndex, collection)}>▶</span>
    </NavContainer>
  )
}

CollectionNavControls.propTypes = {
  collection: PropTypes.object,
  observationId: PropTypes.string,
}

CollectionBar.propTypes = {
  collectionId: PropTypes.string.isRequired,
  observationId: PropTypes.string.isRequired,
}
export default CollectionBar
